export const CART_DIALOG_ID = 'print-order-cart';
